import { CircularProgress, Grid, Typography } from '@mui/material';

const ProgressIndicator = ({ message }: { message?: string }) => {
  return (
    <Grid container justifyContent="center" alignItems={'center'} sx={{ height: '100%' }} spacing={1}>
      <CircularProgress />
      {message && (
        <Typography variant="caption" color="text.secondary">
          {message}
        </Typography>
      )}
    </Grid>
  );
};

export default ProgressIndicator;
